const BUNDLE_STATUS = {
    NOT_STARTED: 'not-started',
    IN_PROGRESS: 'in-progress',
    COMPLETE: 'complete',
};

const STORAGE_KEYS = {
    bundle: 'OD.bundle',
    flagCollapsedStatus: 'OD.bundleFlag',
    shoesPreference: 'OD.shoesPreference',
    sizePreferences: 'OD.sizePreferences',
};

const PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    variantChange: 'variant-change',
    cartError: 'cart-error',
    userLogin: 'user-login',

    pageRerender: 'page-rerender',

    bundleStarted: 'bundle-started',
    bundleCancelled: 'bundle-cancelled',
    bundleCompleted: 'bundle-completed',
};
